import React, { useState } from "react";
import {
  getClientDisplayName,
  getClientInitial,
  resolveClientAvatarUrl,
} from "../utils/clientDisplay";
import "./ClientAvatar.css";

/**
 * Client photo when available (legacy UI parity); otherwise initial circle.
 */
export default function ClientAvatar({
  client,
  className = "",
  imgClassName = "",
  initialClassName = "",
  alt = "",
  size = 36,
}) {
  const [broken, setBroken] = useState(false);
  const url = broken ? "" : resolveClientAvatarUrl(client);
  const initial = getClientInitial(client);
  const label = alt || getClientDisplayName(client);

  const style = { width: size, height: size, minWidth: size };

  if (url) {
    return (
      <span
        className={`client-avatar client-avatar--photo ${className}`.trim()}
        style={style}
      >
        <img
          className={imgClassName}
          src={url}
          alt={label}
          onError={() => setBroken(true)}
        />
      </span>
    );
  }

  return (
    <span
      className={`client-avatar client-avatar--initial ${className} ${initialClassName}`.trim()}
      style={style}
      aria-hidden={!alt}
    >
      {initial}
    </span>
  );
}
